import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import { useLocale } from "@/i18n/LocaleContext";

// Scrollt bei Seitenwechsel nach oben (bzw. zu einem Anker)
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

export const Layout = ({ children }) => {
  const { t } = useLocale();
  return (
    <div className="App min-h-screen flex flex-col bg-cream text-ink">
      <ScrollManager />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:m-3 focus:rounded-xl focus:bg-white focus:px-5 focus:py-3 focus:font-600 focus:text-brand focus:shadow-lg"
      >
        {t.common.skipToContent}
      </a>
      <Header />
      <main id="main" className="flex-1">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
};

export default Layout;
